import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Search } from "lucide-react";

/**
 * The top bar's search: a candidate's own exams. Enter opens My examinations filtered by the text
 * (/student/exams?q=…, read by ExamsV2). Until the 2026-10-16 UI audit (docs/30 F9) the box searched nothing —
 * no handler at all — and promised "courses, assignments, classmates".
 */
export default function TopBarSearch() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [text, setText] = useState("");
  const go = () => {
    const q = text.trim();
    navigate(q ? `/student/exams?q=${encodeURIComponent(q)}` : "/student/exams");
  };
  return (
    <div className="hidden md:flex flex-1 max-w-lg lg:mx-4 items-center gap-2 ux-surface-2 border ux-border rounded-xl px-3 h-10 focus-within:border-indigo-400 focus-within:ux-shadow-md transition">
      <Search className="w-4 h-4 ux-text-muted" />
      <input
        type="search"
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter") go(); }}
        aria-label={t("topbar.search_placeholder")}
        placeholder={t("topbar.search_placeholder")}
        className="bg-transparent outline-none text-[13px] flex-1 ux-text placeholder:text-[var(--ux-text-muted)]"
      />
    </div>
  );
}
